import React, { useCallback } from 'react'

import { useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { BasketContainer } from 'routes/Menu/components/Basket/BasketContainer'
import { useBasket } from 'routes/Menu/domains/basket'
import { getBasketMenuUuid } from 'selectors/basket'

import { MenuExperienceRecipeDetailOverlay } from '../MenuExperiencePage/MenuExperienceRecipeDetailOverlay'
import {
  MenuExperienceRecipeDetailProvider,
  useMenuExperienceRecipeDetails,
} from '../MenuExperiencePage/menuExperienceRecipeDetailContext'

const BasketWithMenuExperienceRecipeDetails = () => {
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()
  const handleRecipeClick = useCallback(
    (recipeId: RecipeUUID, recipeTitle: string) =>
      openRecipeDetail({
        recipeId,
        title: recipeTitle,
        source: 'basket',
      }),
    [openRecipeDetail],
  )

  return <BasketContainer onRecipeClick={handleRecipeClick} />
}

export const MenuExperienceBasketContainer = () => {
  const { updateRecipePortionsByUuid } = useBasket()
  const basketMenuUuid = useSelector(getBasketMenuUuid)

  return (
    <MenuExperienceRecipeDetailProvider
      key={basketMenuUuid}
      menuId={basketMenuUuid}
      updateRecipePortions={updateRecipePortionsByUuid}
    >
      <BasketWithMenuExperienceRecipeDetails />
      <MenuExperienceRecipeDetailOverlay />
    </MenuExperienceRecipeDetailProvider>
  )
}
